if (!window.clinikoBookingTrackingInitialised) {
  window.clinikoBookingTrackingInitialised = true;

  window.addEventListener("message", function (e) {
    if (typeof e.data !== "string") return;

    if (e.data.indexOf("cliniko-bookings-page:confirmed") > -1) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "clinikoBookingCompleted"
      });
    }
  });
}